<template>
  <div>
    <h3 class="mb-4">Personal & Legal Information</h3>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          label="Full Name (as per Passport) (UA)"
          v-model="employee.Passport_FullName_UA"
          :readonly="!editMode"
        ></v-text-field>
        <v-text-field
          label="Tax ID Number (ІПН)"
          v-model="employee.Tax_ID_Number"
          type="number"
          :readonly="!editMode"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          label="Passport Number (Series and Number)"
          v-model="employee.Passport_Full_Number"
          :readonly="!editMode"
        ></v-text-field>
        <v-text-field
          label="Registered Address (UA)"
          v-model="employee.Registered_Address_UA"
          :readonly="!editMode"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="auto">
        <v-btn
          v-if="editMode"
          color="red darken-2 white--text"
          small
          class="mr-3"
          @click="cancelChanges"
        >
          Cancel
        </v-btn>
        <v-btn
          color="success"
          small
          :loading="loading"
          @click="toggleEditMode"
        >
          {{ editMode ? 'Save' : 'Edit' }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'EmployeePersonalData',
  props: {
    value: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      editMode: false,
      copyOfEmployee: null
    }
  },
  computed: {
    employee: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    toggleEditMode () {
      if (this.editMode) {
        this.saveData()
      } else {
        this.copyOfEmployee = JSON.parse(JSON.stringify(this.employee))
        this.editMode = true
      }
    },
    cancelChanges () {
      this.employee.Tax_ID_Number = this.copyOfEmployee.Tax_ID_Number
      this.employee.Passport_FullName_UA = this.copyOfEmployee.Passport_FullName_UA
      this.employee.Passport_Full_Number = this.copyOfEmployee.Passport_Full_Number
      this.employee.Registered_Address_UA = this.copyOfEmployee.Registered_Address_UA
      this.editMode = false
    },
    saveData () {
      this.loading = true
      this.axios.put(`/api/employee_personal_data/${this.employee.Employee_ID}`, {
        Passport_FullName_UA: this.employee.Passport_FullName_UA,
        Passport_Full_Number: this.employee.Passport_Full_Number,
        Tax_ID_Number: this.employee.Tax_ID_Number,
        Registered_Address_UA: this.employee.Registered_Address_UA
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'Personal data successfully saved!' })
        this.editMode = false
        this.copyOfEmployee = null
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.v-text-field--readonly >>> fieldset {
  border-style: none;
}
</style>
